import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
  isAdmin: false,
};

const userReducer = createReducer(initialState, (builder) => {
  builder

    .addCase("LoadUserRequest", (state) => {
      state.loading = true;
    })
    .addCase("LoadUserSuccess", (state, action) => {
      state.isAuth = true;
      state.loading = false;
      state.user = action.payload;
      if(action.payload.role === "admin"){
        state.isAdmin = true;
      }

      
    })
    .addCase("LoadUserFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuth = false;
    })
    .addCase("LogoutUserRequest", (state) => {
      state.loading = true;
    })
    .addCase("LogoutUserSuccess", (state, action) => {
      state.isAuth = false;
      state.isAdmin = false;
      state.loading = false;
      state.logoutMessage = action.payload;
    })
    .addCase("LogoutUserFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    })
    // update user information
    .addCase("updateUserInfoRequest", (state) => {
      state.loading = true;
    })
    .addCase("updateUserInfoSuccess", (state, action) => {
      state.loading = false;
      state.user = action.payload;
    })
    .addCase("updateUserInfoFailed", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // get all users --- admin
    .addCase("getAllUsersRequest", (state) => {
      state.usersLoading = true;
    })
    .addCase("getAllUsersSuccess", (state, action) => {
      state.usersLoading = false;
      state.users = action.payload;
    })
    .addCase("getAllUsersFailed", (state, action) => {
      state.usersLoading = false;
      state.error = action.payload;
    })

    .addCase('get_Fillter_users_request' , (state) => {
      state.isLoading = true;
    })
    .addCase('get_Fillter_users_success', (state,action) => {
      state.isLoading = false;
      state.FillterUsers = action.payload.users;
      state.pagination = action.payload.pagination;
      state.totalusers=action.payload.totalusers
    })
    .addCase("get_Fillter_users_error", (state,action) => {
      state.isLoading = false;
      state.errfiter = action.payload;
    })
    .addCase("get_user_request", (state) => {
      state.isLoadinguser = true;
    })
    .addCase("get_user_success", (state,action) => {
      state.isLoadinguser = false;
      state.userData = action.payload;
    })
    .addCase("get_user_error", (state,action) => {
      state.isLoadinguser = false;
      state.erroruserData = action.payload;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    })
    .addCase("clearMessages", (state) => {
      state.successMessage = null;
    });
});
export default userReducer;
